const labels = {
  communicationPreferences: 'Communication Preferences',
  privacyPolicy: 'Privacy Policy',
  termsAndConditions: 'Terms & Conditions',
  advertiserDisclosure: 'Advertiser Disclosure',
  support: 'Support',
}

export default labels
